import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";

function PdfOpenActionConfirmDialog({
  open,
  message,
  errors = [],
  onConfirm,
  onCancel,
  loading = false,
}) {
  return (
    <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Abertura automática no PDF</DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          {message ||
            "Um ou mais PDFs contêm abertura automática. O conteúdo do documento não será alterado; apenas a abertura automática será removida. Se você não autorizar a remoção, a solicitação não será salva e não será possível concluí-la."}
        </Alert>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Deseja continuar e remover apenas a abertura automática?
        </Typography>
        {errors.length > 0 && (
          <List dense>
            {errors.map((item) => (
              <ListItem key={item.field || item.message} disableGutters>
                <ListItemText
                  primary={item.field}
                  secondary={item.message}
                  primaryTypographyProps={{ variant: "body2", fontWeight: 600 }}
                  secondaryTypographyProps={{ variant: "caption" }}
                />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} disabled={loading} color="inherit">
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? "Enviando..." : "Continuar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default PdfOpenActionConfirmDialog;
